import React, { useState } from 'react';
import { submitContactForm } from '../services/api';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        brandName: '',
        email: '',
        contactNumber: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation
        if (!formData.name.trim() || !formData.email.trim() || !formData.contactNumber.trim()) {
            setError('Please fill in all required fields');
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await submitContactForm(formData);

            if (response.success) {
                setSuccess(true);
                setTimeout(() => {
                    onClose();
                    setSuccess(false);
                    setFormData({
                        name: '',
                        brandName: '',
                        email: '',
                        contactNumber: '',
                        message: ''
                    });
                }, 2000);
            } else {
                setError(response.message || 'Failed to submit form');
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}><i className="ri-close-line"></i></button>

                {success ? (
                    <div className="success-message">
                        <div className="success-icon"><i className="ri-check-line"></i></div>
                        <h2>Thank You!</h2>
                        <p>We'll get back to you soon.</p>
                    </div>
                ) : (
                    <div className="modal-body">
                       <h2 className="modal-title">Get Started with Collaboration World</h2>
                        <p className="modal-subtitle">Fill in your details and we'll reach out to you</p>

                         <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <label htmlFor="name">Full Name *</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="John Doe"
                                    disabled={loading}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="brandName">Brand Name</label>
                                <input
                                    type="text"
                                    id="brandName"
                                    name="brandName"
                                    value={formData.brandName}
                                    onChange={handleChange}
                                    placeholder="Your Brand"
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email Address *</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="john@example.com"
                                    disabled={loading}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="contactNumber">Contact Number *</label>
                                <input
                                    type="tel"
                                    id="contactNumber"
                                    name="contactNumber"
                                    value={formData.contactNumber}
                                    onChange={handleChange}
                                    placeholder="+91 2345678900"
                                    disabled={loading}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Tell us about your brand and goals..."
                                    rows="4"
                                    disabled={loading}
                                />
                            </div>

                            {error && <div className="error-message">{error}</div>}

                            <button type="submit" className="submit-button" disabled={loading}>
                                {loading ? 'Submitting...' : 'Send Message'}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactModal;
